export default "__VITE_ASSET__a4b32e6e__"